import type { Components } from '@mui/material/styles/components';
import type { Theme } from '@mui/material/styles/createTheme';

import { MuiAppBar } from './AppBar';
import { MuiContainer } from './Container';
import { MuiOutlinedInput } from './OutlinedInput';
import { MuiInputBase } from './InputBase';
import { MuiButtonBase } from './ButtonBase';
import { MuiButton } from './Button';
import { MuiInputAdornment } from './InputAdornment';
import { MuiAlert } from './Alert';
import { MuiAlertTitle } from './AlertTitle';
import { MuiChip } from './Chip';
import { MuiTab } from './Tab';
import { MuiTabs } from './Tabs';
import { MuiCard } from './Card';
import { MuiCardContent } from './CardContent';
import { MuiFormLabel } from './FormLabel';
import { MuiSlider } from './Slider';
import { MuiCheckbox } from './Checkbox';
import { MuiFormHelperText } from './HelperText';
import { MuiDialog } from './Dialog';
import { MuiDialogActions } from './DialogActions';
import { MuiFilledInput } from './MuiFilledInput';
import { MuiList } from './List';
import { MuiPopover } from './Popover';
import { MuiSelect } from './Select';
import { MuiAutocomplete } from './Autocomplete';
import { MuiPopper } from './Popper';
import { MuiToggleButtonGroup } from './ToggleButtonGroup';
import { MuiToggleButton } from './ButtonToggle';
import { MuiIconButton } from './IconButton';
import { MuiRadio } from './Radio';
import { MuiSwitch } from './Switch';

export const components: Components<Omit<Theme, 'components'>> = {
  MuiAppBar,
  MuiContainer,
  MuiOutlinedInput,
  MuiInputBase,
  MuiButtonBase,
  MuiButton,
  MuiInputAdornment,
  MuiAlert,
  MuiAlertTitle,
  MuiChip,
  MuiTab,
  MuiTabs,
  MuiCardContent,
  MuiCard,
  MuiFormLabel,
  MuiSlider,
  MuiCheckbox,
  MuiFormHelperText,
  MuiDialog,
  MuiDialogActions,
  MuiFilledInput,
  MuiList,
  MuiPopover,
  MuiSelect,
  MuiAutocomplete,
  MuiPopper,
  MuiToggleButtonGroup,
  MuiToggleButton,
  MuiIconButton,
  MuiRadio,
  MuiSwitch,
};
